module.exports = __webpack_public_path__ + "fontawesome-webfont.af7ae505a9eed503f8b8.woff2";


//////////////////
// WEBPACK FOOTER
// E:/PROJETO SUFRAMA/DESENVOLVIMENTO/Projetos/SCIEX/sciex/src/Suframa.Sciex.UserInterface/www/assets/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = ../../../../../www/assets/fonts/fontawesome-webfont.woff2?v=4.7.0
// module chunks = styles